// Board color themes. Each theme defines the CSS variables consumed by
// GameBoard.css. The default ("classic") matches the original beige/brown
// palette so unthemed installs render identically.

export const THEMES = {
  classic: {
    label: 'Classic',
    light: '#f0d9b5',
    dark: '#b58863',
    border: '#222222',
    selected: '#f7ec2e',
    selectedRing: '#ff6b6b',
    highlighted: '#7dd3fc',
    highlightedRing: '#0369a1',
    dragOver: '#93c5fd',
    dragOverRing: '#1d4ed8',
  },
  green: {
    label: 'Tournament Green',
    light: '#eeeed2',
    dark: '#769656',
    border: '#2d3a22',
    selected: '#f7ec2e',
    selectedRing: '#ff6b6b',
    highlighted: '#bbcb44',
    highlightedRing: '#4a6018',
    dragOver: '#a8c47a',
    dragOverRing: '#2d4a18',
  },
  blue: {
    label: 'Ocean Blue',
    light: '#dee3e6',
    dark: '#788a94',
    border: '#2d3a44',
    selected: '#fce96a',
    selectedRing: '#e89c1c',
    highlighted: '#7dd3fc',
    highlightedRing: '#0369a1',
    dragOver: '#93c5fd',
    dragOverRing: '#1d4ed8',
  },
  midnight: {
    label: 'Midnight',
    light: '#454545',
    dark: '#262626',
    border: '#0a0a0a',
    selected: '#e8b339',
    selectedRing: '#f7ec2e',
    highlighted: '#3a78c4',
    highlightedRing: '#7dd3fc',
    dragOver: '#4a5fa8',
    dragOverRing: '#93c5fd',
  },
};

const STORAGE_KEY = 'boardTheme';

export function applyTheme(name) {
  const theme = THEMES[name] || THEMES.classic;
  const root = document.documentElement;
  root.style.setProperty('--board-light', theme.light);
  root.style.setProperty('--board-dark', theme.dark);
  root.style.setProperty('--board-border', theme.border);
  root.style.setProperty('--board-selected', theme.selected);
  root.style.setProperty('--board-selected-ring', theme.selectedRing);
  root.style.setProperty('--board-highlighted', theme.highlighted);
  root.style.setProperty('--board-highlighted-ring', theme.highlightedRing);
  root.style.setProperty('--board-drag-over', theme.dragOver);
  root.style.setProperty('--board-drag-over-ring', theme.dragOverRing);
  root.dataset.theme = name;
}

export function getSavedTheme() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved && THEMES[saved] ? saved : 'classic';
  } catch {
    return 'classic';
  }
}

export function saveTheme(name) {
  if (!THEMES[name]) return;
  try { localStorage.setItem(STORAGE_KEY, name); } catch {}
  applyTheme(name);
}
